/** The origin of the page framing this one, when the browser says. */
export function parentOrigin(): string | null {
  const ancestors = window.document.location.ancestorOrigins
  if (ancestors && ancestors.length > 0) {
    return ancestors.item(0)
  }
  if (!window.document.referrer) {
    return null
  }
  try {
    return new URL(window.document.referrer).origin
  } catch {
    return null
  }
}

/** Whether this page is inside a frame; only the embed page may be framed. */
export function isFramed(): boolean {
  try {
    return window.self !== window.top
  } catch {
    // A cross-origin parent can block even the comparison; that's a frame too.
    return true
  }
}
